import React, {useContext} from 'react';
import Products from './Products';
import PageHeader from './PageHeader';
import Pagination from './Pagination';
import Breadcrumb from './Breadcrumb';
import WooSidebar from './WooSidebar';
import Filters from "./Filters";
import Button from "./Elements/Button"
import {WooContext} from "./WooContext";
import {toggleFilters} from "./Functions/Helpers";

function App() {
    const {products} = useContext(WooContext);
  return (
        <div className="woo-react">
            <Breadcrumb/>
            <div className="inner-container">
                <PageHeader/>
            </div>
            <div className="inner-container woo-container">
                <WooSidebar>
                    <Filters/>
                </WooSidebar>
                <div className="main-content">
                    <Products products={products} />
                    <Pagination products={products} />
                </div>
                <Button className="filters-button d-lg-none" onClick={()=> toggleFilters()}>Filter Products</Button>
            </div>
        </div>
  );
}

export default App;
